import { Variable, VariableState } from '@/types/TVariables';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: VariableState = {
	variables: {},
};

export const variableSlice = createSlice({
	name: 'variableManager',
	initialState,
	reducers: {
		setVariable: (state, action: PayloadAction<{ name: string; data: Variable }>) => {
			state.variables[action.payload.name] = action.payload.data;
		},

		removeVariable: (state, action: PayloadAction<string>) => {
			const { [action.payload]: _, ...rest } = state.variables;
			state.variables = rest;
		},

		updateVariable: (state, action: PayloadAction<{ name: string; data: Partial<Variable> }>) => {
			if (state.variables[action.payload.name]) {
				state.variables[action.payload.name] = {
					...state.variables[action.payload.name],
					...action.payload.data,
				};
			}
		},

		resetVariables: () => structuredClone(initialState),
	},
});

export const { setVariable, removeVariable, updateVariable, resetVariables } =
	variableSlice.actions;
export default variableSlice.reducer;
